import { advantages } from '@/mocks/home';

export default function AdvantageSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-500 tracking-widest uppercase mb-2 font-label">品牌优势</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            为什么选择开云
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            十余年品牌积淀，数百万用户信赖，以实力铸就品质，以真诚赢得口碑
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {advantages.map((adv) => (
            <div
              key={adv.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/50 hover:border-accent-200 transition-all duration-300 group"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${adv.icon} text-accent-600 group-hover:text-white text-xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2">{adv.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{adv.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}